<!--
 * @Author: vince
 * @Date: 2021-08-31 09:43:51
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-17 10:07:32
 * @Description:
-->
<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none" label="学年">
          <school-year-selector
            v-model="filterForm.schoolYear"
            @change="refresh"
          ></school-year-selector>
        </el-form-item>
        <el-form-item class="mb-none" label="学期">
          <school-term-selector
            v-model="filterForm.schoolTerm"
            @change="refresh"
          ></school-term-selector>
        </el-form-item>
        <el-form-item class="mb-none" label="状态">
          <dic-selector
            size="small"
            checkAll
            @loaded="onCheckStatusLoaded"
            dicType="checkStatus"
            v-model="filterForm.checkStatus"
            @change="refresh"
          ></dic-selector>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索教师姓名"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <div class="space"></div>
        <el-button
          v-if="userInfo && power(userInfo.menuInfoList, 'teachingTask-export')"
          type="primary"
          class="el-icon-upload2"
          size="small"
          @click="toExport"
          >导出</el-button
        >
        <el-button
          v-if="userInfo && power(userInfo.menuInfoList, 'teachingTask-examine')"
          size="small"
          type="primary"
          icon="el-icon-s-check"
          :disabled="selection.length == 0"
          @click="onCheck"
          >审核</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          >新增带教任务</el-button
        >
      </div>
    </el-form>
    <el-table
      :data="tableData"
      @selection-change="onSelectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="schoolYear"
        label="学年"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="schoolTerm"
        label="学期"
        align="center"
        :formatter="schoolTermFormatter"
      ></el-table-column>
      <el-table-column
        prop="teacherName"
        label="带教人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="teachedName"
        label="被带教人"
        align="center"
      ></el-table-column>
      <el-table-column prop="startDate" label="起止日期" align="center">
        <template slot-scope="scope"
          >{{ scope.row.startDate }} 至 {{ scope.row.endDate }}</template
        >
      </el-table-column>
      <el-table-column
        prop="checkName"
        label="审核人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="checkStatus"
        label="状态"
        align="center"
        :formatter="checkStatusFormatter"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="updateTime" label="修改日期" align="center"></el-table-column> -->
      <el-table-column
        prop="classify"
        label="带教等级"
        align="center"
        :formatter="classifyFormatter"
      ></el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            :disabled="rowActionDisabled(scope.row)"
            @click="onEdit(scope.row)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              :disabled="rowActionDisabled(scope.row)"
              slot="reference"
              type="text"
              class="danger"
              size="small"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="filterForm"
      ></pagination>
    </el-table>
    <el-dialog
      title="新增带教任务"
      :visible.sync="dialogNewTask"
      @closed="onDialogNewTaskClose"
    >
      <!-- 避免对话框关闭时仍挂载 AuthorSelector：其 created 会立刻请求 /user/getTeacherInfoList，失败时全局弹出「未登录」类提示 -->
      <el-form
        v-if="dialogNewTask"
        v-loading="saving"
        class="content-box"
        label-width="140px"
        ref="elNewTaskForm"
        :model="newTaskForm"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolYear" label="学年">
              <school-year-selector
                v-model="newTaskForm.schoolYear"
              ></school-year-selector>
            </el-form-item>
          </el-col>
          <el-col :span="24" :xl="{ span: 12 }">
            <el-form-item prop="schoolTerm" label="学期">
              <school-term-selector
                v-model="newTaskForm.schoolTerm"
                :checkAll="false"
              ></school-term-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="带教分类" prop="teachingCodeTemp">
          <el-radio-group v-model="newTaskForm.teachingCodeTemp">
            <el-radio
              v-for="o in teachingCategoryOptions"
              :key="o.dicCode"
              :label="o.dicCode"
              >{{ o.dicName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="带教等级" prop="classifyTemp">
          <dic-selector
            dicType="teachingTaskLevel"
            v-model="newTaskForm.classifyTemp"
          ></dic-selector>
        </el-form-item>
        <el-form-item label="带教人" prop="teacherTemp">
          <author-selector
            class="at"
            :multiple="false"
            v-model="newTaskForm.teacherTemp"
            :schoolCodes="schoolCodesForApi"
            :isReadOnly="userInfo && userInfo.roleCodes == 'teacher'"
          ></author-selector>
        </el-form-item>
        <el-form-item label="带教人任务安排" prop="arrangement">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="500"
            show-word-limit
            v-model="newTaskForm.arrangement"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="被带教人" prop="teachedTemp">
          <author-selector
            class="at"
            :multiple="false"
            v-model="newTaskForm.teachedTemp"
            :schoolCodes="schoolCodesForApi"
          ></author-selector>
        </el-form-item>
        <el-form-item label="被带教人完成情况" prop="situation">
          <el-input
            type="textarea"
            :rows="2"
            maxlength="500"
            show-word-limit
            v-model="newTaskForm.situation"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="起止日期" prop="dateTemp" size="small">
          <el-date-picker
            v-model="newTaskForm.dateTemp"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogNewTask = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AuthorSelector from "../../components/school/authorSelector.vue";
import DicSelector from "../../components/school/dicSelector.vue";
import SchoolTermSelector from "../../components/school/schoolTermSelector.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import { mapGetters, mapState } from "vuex";
import { getData, postData, postJson } from "../../http/fetch.js";
import Pagination from "../../components/Pagination.vue";
import { power, fileSaveZip } from "@/utils/index.js";

/** 新建/编辑表单初始值（避免共用引用导致 id、分类残留） */
function createEmptyTaskForm() {
  return {
    id: null,
    teachingCode: null,
    /** 带教分类 dicCode：学科带教 / 班主任带教（与 saveOrUpdateTeacherTask.teachingCode 一致） */
    teachingCodeTemp: null,
    classify: null,
    classifyTemp: null,
    endDate: null,
    operatorId: null,
    schoolCode: null,
    schoolTerm: null,
    schoolYear: null,
    startDate: null,
    teachedId: null,
    teachedName: null,
    teacherId: null,
    teacherName: null,
    teacherTemp: null,
    teachedTemp: null,
    dateTemp: null,
    arrangement: null,
    situation: null,
  };
}
export default {
  components: {
    schoolYearSelector,
    SchoolTermSelector,
    DicSelector,
    AuthorSelector,
    Pagination,
  },
  name: "teachingTask",
  data() {
    return {
      classifyList: [],
      selection: [],
      checkStatusList: [],
      loading: false,
      pageLoading: false,
      saving: false,
      tableData: [],
      newTaskForm: createEmptyTaskForm(),
      /** 带教分类选项：优先数据字典 teachingCode 等，失败则用与后端常见约定一致的默认项 */
      teachingCategoryOptions: [],
      dialogNewTask: false,
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        keyword: null,
        checkStatus: null,
        size: 10,
        current: 1,
        total: 0,
      },
      rules: {
        teachingCodeTemp: [
          { required: true, message: "请选择带教分类", trigger: "change" },
        ],
        classifyTemp: [
          { required: true, message: "请选择级别", trigger: "change" },
        ],
        schoolTerm: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        teacherTemp: [
          { required: true, message: "请选择带教人", trigger: "change" },
        ],
        teachedTemp: [
          { required: true, message: "请选择被带教人", trigger: "change" },
        ],
        dateTemp: [
          { required: true, message: "请选择时间段", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    ...mapGetters(["schoolCode", "operatorId", "schoolCodes"]),
    /**
     * teacherSchoolList 为空时（常见：管理员仅有 schoolCode），getter schoolCodes 为 []。
     * /teacherTask/getTeacherTask 等对空 schoolCodes 可能返回「未登录或登录超时」，与其它页 getTeacherInfoList 的兜底一致。
     */
    schoolCodesForApi() {
      const arr = this.schoolCodes;
      if (Array.isArray(arr) && arr.length > 0) return arr;
      return this.schoolCode ? [this.schoolCode] : [];
    },
  },
  watch: {
    teachingCategoryOptions(list) {
      if (
        !list ||
        !list.length ||
        !this.dialogNewTask ||
        this.newTaskForm.id
      ) {
        return;
      }
      if (
        this.newTaskForm.teachingCodeTemp == null ||
        this.newTaskForm.teachingCodeTemp === ""
      ) {
        this.$set(this.newTaskForm, "teachingCodeTemp", list[0].dicCode);
      }
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.loadTeachingCategoryOptions();
    this.getDic("teachingTaskLevel")
      .then((res) => {
        this.classifyList = res;
      })
      .catch(() => {});
  },
  methods: {
    loadTeachingCategoryOptions() {
      const fallbacks = [
        { dicCode: "subject", dicName: "学科带教" },
        { dicCode: "classTeacher", dicName: "班主任带教" },
      ];
      const tryTypes = ["teachingCode", "teachingTaskType", "teachingTaskCode"];
      const attempt = (i) => {
        if (i >= tryTypes.length) {
          this.teachingCategoryOptions = fallbacks;
          return;
        }
        getData("/core/dic/getDictionaryList-page", {
          dicType: tryTypes[i],
          pageNum: 1,
          pageSize: -1,
        })
          .then((res) => {
            if (Array.isArray(res) && res.length > 0) {
              this.teachingCategoryOptions = res.map((m) => ({
                dicCode: m.dicCode,
                dicName: m.dicName,
              }));
            } else {
              attempt(i + 1);
            }
          })
          .catch(() => attempt(i + 1));
      };
      attempt(0);
    },
    toExport() {
      this.pageLoading = true;
      this.$axios
        .post(
          "/teacherTask/exportTeacherTask",
          this.$qs.stringify({
            schoolCodes: this.schoolCodesForApi,
            pageNum: this.filterForm.current,
            pageSize: this.filterForm.size,
            checkStatus: this.filterForm.checkStatus
              ? this.filterForm.checkStatus.dicCode
              : null,
            schoolYear: this.filterForm.schoolYear,
            schoolTerm: this.filterForm.schoolTerm,
            keyword: this.filterForm.keyword,
          }),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          this.pageLoading = false;
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    onAdd() {
      this.newTaskForm = createEmptyTaskForm();
      const firstCode =
        this.teachingCategoryOptions.length > 0
          ? this.teachingCategoryOptions[0].dicCode
          : null;
      if (firstCode != null) {
        this.newTaskForm.teachingCodeTemp = firstCode;
      }
      this.dialogNewTask = true;
      if (this.userInfo && this.userInfo.roleCodes == "teacher") {
        this.newTaskForm.teacherTemp = {
          userId: this.userInfo.userId,
          userName: this.userInfo.userName,
        };
      }
    },
    isRoleAdmin(info) {
      if (!info || info.roleCodes == null) return false;
      const r = info.roleCodes;
      if (Array.isArray(r)) return r.includes("admin");
      return String(r).includes("admin");
    },
    rowActionDisabled(row) {
      if (!this.userInfo) return true;
      if (this.isRoleAdmin(this.userInfo)) return false;
      return this.userInfo.userId != row.createBy;
    },
    power,
    classifyFormatter(row, column, cellValue, index) {
      let result = cellValue;

      let find = this.classifyList.find((f) => f.dicCode == cellValue);
      if (find) {
        result = find.dicName;
      }
      return result;
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData("/core/dic/getDictionaryList-page", {
          dicType: dicType,
          pageNum: 1,
          pageSize: -1,
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName,
              };
            });
            resolve(res);
          } else {
            reject();
          }
        });
      });
    },
    onSelectionChange(val) {
      this.selection = val;
    },
    onCheckStatusLoaded(list) {
      this.checkStatusList = list;
    },
    schoolTermFormatter(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "上";
      } else if (cellValue == 2) {
        return "下";
      } else if (cellValue == 3) {
        return "全部";
      }
    },
    checkStatusFormatter(row, column, cellValue, index) {
      let result = cellValue;
      let find = this.checkStatusList.find((f) => f.dicCode == cellValue);
      if (find) {
        result = find.dicName;
      }
      return result;
    },
    onDialogNewTaskClose() {
      if (this.$refs.elNewTaskForm) {
        this.$refs.elNewTaskForm.resetFields();
      }
      this.newTaskForm = createEmptyTaskForm();
    },
    handleClick() {},
    check(status) {
      postJson("/teacherTask/batchReview", {
        checkStatus: status,
        ids: this.selection.map((m) => m.id),
        operatorId: this.operatorId,
      }).then((res) => {
        this.$message.success("审核成功！");
        this.getData();
      });
    },
    onCheck() {
      this.$confirm("请确认选中项无误！", "审核", {
        distinguishCancelAndClose: true,
        confirmButtonText: "审核通过",
        cancelButtonText: "不通过",
      })
        .then(() => {
          this.check(1);
        })
        .catch((action) => {
          if (action === "cancel") {
            this.check(2);
          }
        });
    },
    refresh() {
      this.filterForm.pageNum = 1;
      this.getData();
    },
    onDel(row) {
      this.saving = true;
      postData("/teacherTask/removeTeacherTask", { id: row.id })
        .then((res) => {
          this.getData();
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
    getData() {
      this.loading = true;
      postJson("/teacherTask/getTeacherTask", {
        schoolCodes: this.schoolCodesForApi,
        schoolCode: this.schoolCode,
        operatorId: this.operatorId,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        checkStatus: this.filterForm.checkStatus
          ? this.filterForm.checkStatus.dicCode
          : null,
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm,
        keyword: this.filterForm.keyword,
      })
        .then((res) => {
          this.tableData = res.records;
          this.filterForm.size = res.size;
          this.filterForm.total = res.total;
          this.filterForm.current = res.current;
        })
        .catch((e) => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEdit(row) {
      const code =
        row.teachingCode != null && row.teachingCode !== ""
          ? row.teachingCode
          : this.teachingCategoryOptions.length > 0
            ? this.teachingCategoryOptions[0].dicCode
            : null;
      this.newTaskForm = {
        id: row.id,
        teachingCode: row.teachingCode,
        teachingCodeTemp: code,
        classify: row.classify,
        classifyTemp: {
          dicCode: row.classify,
        },
        arrangement: row.arrangement,
        situation: row.situation,
        endDate: row.endDate,
        schoolTerm: row.schoolTerm,
        schoolYear: row.schoolYear,
        startDate: row.startDate,
        teachedId: row.teachedId,
        teachedName: row.teachedName,
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        teacherTemp: {
          userId: row.teacherId,
          userName: row.teacherName,
        },
        teachedTemp: {
          userId: row.teachedId,
          userName: row.teachedName,
        },
        dateTemp: [row.startDate, row.endDate],
      };
      this.dialogNewTask = true;
    },
    onSave() {
      this.$refs.elNewTaskForm.validate((valid) => {
        if (valid) {
          const classify =
            this.newTaskForm.classifyTemp &&
            this.newTaskForm.classifyTemp.dicCode != null
              ? this.newTaskForm.classifyTemp.dicCode
              : null;
          const teachingCode =
            this.newTaskForm.teachingCodeTemp != null &&
            this.newTaskForm.teachingCodeTemp !== ""
              ? this.newTaskForm.teachingCodeTemp
              : null;
          if (
            !this.newTaskForm.dateTemp ||
            !Array.isArray(this.newTaskForm.dateTemp) ||
            this.newTaskForm.dateTemp.length < 2
          ) {
            this.$message.warning("请选择起止日期");
            return;
          }
          this.saving = true;
          postJson("/teacherTask/saveOrUpdateTeacherTask", {
            id: this.newTaskForm.id ? this.newTaskForm.id : null,
            teachingCode,
            classify,
            endDate: this.newTaskForm.dateTemp[1],
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            schoolTerm: this.newTaskForm.schoolTerm,
            schoolYear: this.newTaskForm.schoolYear,
            teachedId: this.newTaskForm.teachedTemp.userId,
            teachedName: this.newTaskForm.teachedTemp.userName,
            teacherId: this.newTaskForm.teacherTemp.userId,
            teacherName: this.newTaskForm.teacherTemp.userName,
            startDate: this.newTaskForm.dateTemp[0],
            arrangement: this.newTaskForm.arrangement,
            situation: this.newTaskForm.situation,
          })
            .then((res) => {
              this.dialogNewTask = false;
              this.$message.success("操作成功！");
              this.filterForm.pageNum = 1;
              this.getData();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
  },
};
</script>
<style>
.at {
  margin-left: 0 !important;
}
</style>
<style scoped>
.el-button.is-disabled.el-button--text {
  color: #c0c4cc !important;
}
</style>
